import { useState } from "react";
import classnames from "classnames";
export interface PingStatsModuleProps {
  pingStats: Record<PingType, number>;
}

interface PingModuleProps {
  ping: string;
  value: number;
  revealed: boolean;
}

const PING_TYPES = ["allin", "retreat", "omw", "push", "assist", "vision", "missing", "enemyvision"] as const;

export type PingType = (typeof PING_TYPES)[number];

export function PingModule(props: PingModuleProps) {
  const { ping, value, revealed } = props;

  const imageUrl = `https://static.bigbrain.gg/assets/lol/icons/icon_ping_${ping}.png`;
  const formattedNumber = value.toLocaleString("en-US");
  return (
    <div className="flex flex-col items-center gap-6">
      <img src={imageUrl} alt={`${ping} Icon`} className="w-[60px] h-[60px] shrink-0" />
      <div className="w-[60px] h-[1px] shrink-0 bg-[radial-gradient(50%_50%_at_50%_50%,#F4C874_0%,rgba(244,200,116,0.00)_100%)] shadow-[0_2px_0_0_rgba(0,0,0,0.40)] " />
      <div
        className={classnames(
          "text-[#CDDCFE] text-center font-inter text-lg font-normal transition-all duration-700 ease-in-out",
          { "blur-sm": !revealed },
        )}
      >
        {formattedNumber}
      </div>
    </div>
  );
}

export function PingStatsModule(props: PingStatsModuleProps) {
  const [isRevealed, setIsRevealed] = useState(false);
  const { pingStats } = props;

  return (
    <div className="flex flex-col items-center gap-[60px]">
      <div className="flex gap-12 justify-center">
        {PING_TYPES.map((key) => (
          <PingModule key={key} ping={key} value={pingStats[key]} revealed={isRevealed} />
        ))}
      </div>
      <button
        onClick={() => setIsRevealed(!isRevealed)}
        className="h-12 w-[155px] inline-flex py-[10px] px-[18px] justify-center items-center shrink-0 bg-accent-blue-400 hover:bg-accent-blue-600 rounded-[3px]"
      >
        <span className="text-white font-inter text-[18px] font-bold leading-normal cursor-pointer">
          {isRevealed ? "Hide Results" : "Show Results"}
        </span>
      </button>
    </div>
  );
}
